import React from "react";
import NotificationPreferencesSection from "./notification-preferences/NotificationPreferencesSection";
import PushPermissionSection from "./notification-preferences/PushPermissionSection";

export default function SettingsPushNotificationsPage({ currentUser }) {
  return (
    <div className="rp-settings-push-page">
      <PushPermissionSection key="push-registration-lifecycle-consumer" />
      <NotificationPreferencesSection
        key={currentUser?.id || currentUser?.username || "signed-out"}
        accountKey={currentUser?.id || currentUser?.username || null}
      />
    </div>
  );
}
